import { render, staticRenderFns } from "./loginpage.html?vue&type=template&id=5d2f08bb&scoped=true&"
import script from "./loginpage.js?vue&type=script&lang=js&"
export * from "./loginpage.js?vue&type=script&lang=js&"
import style0 from "./loginpage.scss?vue&type=style&index=0&id=5d2f08bb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2f08bb",
  null
  
)

export default component.exports